export default {"src":"/_next/static/media/darkGrid.81c365b9.svg","height":722,"width":632,"blurWidth":0,"blurHeight":0};